import moment from 'moment-timezone'

export const calculateAutoBookingTimes = ({
  length,
  start,
}) => {
  const earliest = start
  const latest = moment(start).add(length, 'm')
  const appointmentTimes = ['- select -', earliest]
  let nextTime = moment(earliest).add(30, 'm')

  while (nextTime.isBefore(latest)) {
    appointmentTimes.push(nextTime)
    nextTime = moment(nextTime).add(30, 'm')
  }

  appointmentTimes.push(latest, 'Custom')
  return appointmentTimes
}

const aptTimeIsCustom = autoAptTime => autoAptTime === 'Custom'
const aptTimeIsSelect = autoAptTime => autoAptTime === '- select -'
export const disableSubmitButton = autoAptTime =>
  !autoAptTime || aptTimeIsSelect(autoAptTime) || aptTimeIsCustom(autoAptTime)

const buildTimeStrings = appointmentTimes =>
  appointmentTimes.map(
    time => (moment.isMoment(time) ? time.format('HH:mm') : time),
  )

export const validCustomTime = (appointmentTimes, autoAptTime) => {
  if (!autoAptTime) return false
  return (
    aptTimeIsCustom(autoAptTime) ||
    !buildTimeStrings(appointmentTimes).includes(autoAptTime)
  )
}

export const formatTimeString = (time, start, outputFormat) => {
  const hhmmAptTime = time.split(':')
  return start
    .hour(hhmmAptTime[0])
    .minute(hhmmAptTime[1])
    .format(outputFormat)
}

// convert a 24 hour time string to 12
export const formatTime = (timeStr) => {
  const timeArr = timeStr.split(':')
  const period = timeArr[0] > 11 ? 'pm' : 'am'
  // overly cleaver way of converting a 24 hour to 12
  const hour = (((parseInt(timeArr[0], 10) + 11) % 12) + 1)
  return `${hour}:${timeArr[1]} ${period}`
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/helpers.js